import { useEffect, useRef } from 'react';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@nazka/nazka.mapframe.components';

import './constraints-popup.css';

function ConstraintsPopup({ color, onClose, score, title }) {
  const popupRef = useRef(null);

  useEffect(() => {
    const handleOutsidePointerDown = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('pointerdown', handleOutsidePointerDown);
    return () => document.removeEventListener('pointerdown', handleOutsidePointerDown);
  }, [onClose]);

  return (
    <div ref={popupRef} className="constraints-popup">
      <div className="constraints-popup__header">
        <h2 className="constraints-popup__title">{title}</h2>
        <Button
          aria-label="Close popup"
          className="constraints-popup__close"
          icon={faClose}
          iconSize="14px"
          onClick={onClose}
          type="button"
          layout="ghost"
          hover={false}
        />
      </div>
      <div className="constraints-popup__score">
        <span
          aria-hidden="true"
          className="constraints-popup__swatch"
          style={{ backgroundColor: color }}
        />
        <span>
          {'Score: '}
          {score}
        </span>
      </div>
    </div>
  );
}

export default ConstraintsPopup;
